module.exports = __webpack_public_path__ + "static/img/IMG_20160307_115909.9ef0083b.jpg";